module.exports = __webpack_public_path__ + "4ebddec8df3de750a2c5366f18a4528f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/smoothie-s.png
// module id = 2608
// module chunks = 0